import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row } from 'react-bootstrap';

import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    className: PropTypes.string,
    parentName: PropTypes.string,
    depth: PropTypes.number,
    goUp: PropTypes.func.isRequired,
};

const defaultProps = {
    className: '',
    parentName: '',
    depth: 0,
};

function FolderListItem(props) {
    function _goUp(e) {
        e.stopPropagation();
        props.goUp();
    }

    return (
        <li className={`${props.className} listing--noBg projectListing`}>
            <Row className="projectListing__wrapper">
                <div
                    className={`col-3 col-sm-2 col-md-1 projectListing__col--control projectListing__col--depth-${props.depth} nowrap`}
                >
                    <button 
                        className="bare-text-button no-button-style width-100p height-100p text-left padding-l-sm"
                        onClick={_goUp}
                    >
                        <AccessibleIcon className="fa fa-folder fa-lg fa-fw margin-right-sm" label="Folder" />
                        <AccessibleIcon className="fa fa-level-up" label="Up Level" />
                    </button>
                </div>
                <button
                    className="bare-text-button no-button-style col-7 col-sm-7 col-md-5 col-lg-3 projectListing__col link-plain link-body-color font-style-italic"
                    onClick={_goUp}
                >
                    {!!props.parentName ?
                        `Up to ${props.parentName}`
                        :
                        'Go up'
                    }
                </button>
                <button
                    className="bare-text-button no-button-style col-3 col-sm-3 col-md-6 col-lg-8"
                    onClick={_goUp}
                >
                </button>
            </Row>
        </li>
    );
}

FolderListItem.propTypes = propTypes;
FolderListItem.defaultProps = defaultProps;

export default FolderListItem;
